<style scoped lang="scss">
    .orders{
        padding-bottom: 40px;
    }
    .orders-header {
        width: 1140px;
        margin-top: 40px;
        padding: 12px 30px;

        .l {
            flex: 1;
            font-size: 16px;

            a {
                display: inline-block;
                padding: 0 0 3px 0;
                margin-right: 20px;
                border-bottom: 2px solid #fff;
                position: relative;
                &.active {
                    color: #E23844;
                    border-color: #E23844;
                }
                .corner {
                    display: block;
                    margin-left: 8px;
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    border-radius: 16px;
                    font-size: 12px;
                    overflow: hidden;
                    background: red;
                    color: #fff;
                    position: absolute;
                    top: -6px;
                    right: -10px;
                }
            }
        }
        .money_type {
            width: 120px;
            margin-right: 10px;
        }
        .search {
            width: 300px;
        }

        .date {
            width: 280px;
            padding-right: 10px;

        }
        .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
            width: 280px;
        }
    }

    .order {
        margin-top: 30px;
        background: white;
        font-size: 14px;

        .header {
            height: 40px;
            line-height: 40px;
            padding-left: 30px;
            background: #fafafa;
            border: 1px solid #f2f2f2;
        }

        .prod {
            width: 500px;
            border-right: 1px solid #f2f2f2;
            padding-bottom: 20px;

            .prod-item {
                margin: 20px 30px 0;

                img {
                    width: 62px;
                    height: 62px;
                    padding: 1px;
                    border: 1px solid #ddd;
                }

                .title {
                    padding: 0 0 0 15px;
                }

                .num {
                    width: 60px;
                    text-align: right;
                    color: #c0c0c0;
                }

            }
        }

        .recipient-sender, .state, .amount {
            border-right: 1px solid #f2f2f2;
            width: 170px;
            text-align: center;
            padding-top: 12px;
            color: #999;
            div{
                margin: 0 20px;
                line-height: 36px;
                &:first-child{
                    border-bottom: 1px solid #eee;
                }
            }
            span{
                color: #444;
            }
        }

        .amount {
            border-right: 1px solid #f2f2f2;
            width: 200px;
            text-align: center;
        }

        .operation {
            text-align: center;
            padding-top: 20px;
            flex: 1;

            span{
                display: block;
                width: 90px;
                height: 26px;
                line-height: 26px;
                color: #90ca6f;
                border: 1px solid #90ca6f;
                border-radius: 5px;
                margin: 0px auto 15px;
                cursor: pointer;
            }
        }
    }

    .pagination{
        padding-top: 40px;
    }
    ::v-deep .update_order {
        min-width: 525px;
        .el-dialog__body {
            padding:10px 20px;
        }
        .el-form-item {
            margin-bottom: 8px;
        }
        .readonly {
            .el-input__inner {
                border: 1px dashed #DCDFE6;
            }
        }
        .reclable {
            label {
                font-size: 17px;
                color: #1ab394;
            }
        }
        .idcard {
            display:inline-block;
            margin-right: 10px;
            width:180px;
            height: 125px;
            border: 1px dashed #ddd;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #f1f9ec;
        color: #90ca6f;
    }
    .fwb {
        font-weight: bold;
    }
</style>
<style lang="scss">
    .order_detail {
        min-width: 740px;
        .title {
            font-size: 18px;
            color: #1ab394;
            height: 40px;
            line-height: 40px;
        }
    }
    .orderinfo {
        height:24px;
        line-height:24px;
        overflow: hidden;
        .fl { float: left;}
        .fr { float: right;}
    }
</style>
<template>
    <div class="orders container">
        <div class="orders-header card rowflex">
            <div class="l">
                <a href="javascript:void(0)" @click="getOrderByStatus()" :class="{active: !filter.Status}">全部订单</a>
                <a href="javascript:void(0)" @click="getOrderByStatus(1)" :class="{active: filter.Status == 1}">
                    待付款
                    <span class="corner" v-if="myOrderCout && myOrderCout.unpaidCount">{{myOrderCout && myOrderCout.unpaidCount}}</span>
                </a>
                <a href="javascript:void(0)" @click="getOrderByStatus(2)" :class="{active: filter.Status == 2}">
                    待发货
                    <span class="corner" v-if="myOrderCout && myOrderCout.unDeliveredCount">{{myOrderCout && myOrderCout.unDeliveredCount}}</span>
                </a>
                <a href="javascript:void(0)" @click="getOrderByStatus(3)" :class="{active: filter.Status == 3}">
                    待收货
                    <span class="corner" v-if="myOrderCout && myOrderCout.unReceiveCount">{{myOrderCout && myOrderCout.unReceiveCount}}</span>
                </a>
            </div>
            <div class="money_type">
                <el-select placeholder="按币种筛选" size="small" filterable clearable v-model="filter.priceType" @change="search">
                    <el-option :label="item.value" :value="item.type" :key="item.type"
                        v-for="item in priceTypes"></el-option>
                </el-select>
            </div>
            <div class="date">
                <el-date-picker
                    v-model="searchDate"
                    type="daterange"
                    align="center"
                    size="small"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </div>
            <div class="search">
                <el-input placeholder="请输入商品名称或订单号" v-model="filter.Keywords" size="small">
                    <el-button slot="append" @click="search()">搜索</el-button>
                </el-input>
            </div>
        </div>
        <div class="order card" v-for="(order, index) in orders.items">
            <div class="header">
                {{order.creationTimeFormated}} 　 订单号：<span class="red">{{order.id}}</span>
            </div>
            <div class="rowflex">
                <div class="prod">
                    <div class="prod-item rowflex" v-for="item in order.items">
                        <img :src="item.commodityImageUrl" alt="item.commodityName"/>
                        <div class="title">{{item.commodityName}}</div>
                        <div class="num">X{{item.quantity}}</div>
                    </div>
                </div>
                <div class="recipient-sender" v-if="!order.tenantId">
                    <div>收件人：<span>{{order.addressee.name}}</span></div>
                    <div><span>{{order.addressee.tel}}</span></div>
                </div>
                <div class="recipient-sender" v-else>
                    <div>取货方式：<span>自提</span></div>
                    <div><span></span></div>
                </div>
                <div class="amount">
                    <div>总金额：<span class="red">{{ getPriceType(order.priceType).symbol }}{{order.totalAmount}}{{ getPriceType(order.priceType).unit }}</span></div>
                    <div><span>{{order.payStatusName}}</span></div>
                </div>
                <div class="state">
                    <div class="orange">订单状态</div>
                    <div><span>{{orderStatusTxt(order)}}</span></div>
                </div>
                <div class="operation">
                    <el-dropdown>
                        <el-button type="success" plain size="mini">
                            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="order.status === 1 && order.payStatus === 0" @click.native="$router.push({path:'pay', query:{orderId:order.id}})">立即付款</el-dropdown-item>
                            <el-dropdown-item @click.native="getOrderDetail(order)">订单详情</el-dropdown-item>
                            <el-dropdown-item v-if="order.status === 1" @click.native="updateOrder(order)">修改订单</el-dropdown-item>
                            <el-dropdown-item v-if="order.status === 1" @click.native="cancelOrder(order.id)">取消订单</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

            </div>
        </div>

        <div class="pagination" v-if="orders.totalCount>filter.Size">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="changePage"
                :page-size="filter.Size"
                :total="orders.totalCount">
            </el-pagination>
        </div>

        <el-dialog
            title="订单详情"
            :visible.sync="dialogDetail" top="5vh"
            width="50%" custom-class="order_detail">
            <div class="title">订单明细</div>
            <el-table :data="detailInfos.items" border style="width: 100%" size="mini">
                <el-table-column prop="commodityName" label="产品名称">
                </el-table-column>
                <el-table-column prop="quantity" label="数量" align="center">
                </el-table-column>
                <el-table-column prop="commodityPrice" label="单价" align="right" :formatter="formatPrice">
                </el-table-column>
            </el-table>
            <el-card class="box-card" shadow="never">
                <div class="orderinfo">
                    <span class="fl">订单总金额:</span>
                    <span class="fr">{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.totalAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">商品金额:</span>
                    <span class="fr">{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.productsAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo" v-if="detailInfos.freight">
                    <span class="fl">快递运费:</span>
                    <span class="fr">{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.freight}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo" v-if="detailInfos.needTakePhoto">
                    <span class="fl">标记拍照服务费:</span>
                    <span class="fr">{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.takePhotoAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo" v-if="detailInfos.serviceAmount>0 && detailInfos.payStatus === 2">
                    <span class="fl">手续费:</span>
                    <span class="fr">{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.serviceAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo" v-if="detailInfos.cashAmount>0">
                    <span class="fl">余额抵扣:</span>
                    <span class="fr">-{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.cashAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo" v-if="detailInfos.couponAmount>0">
                    <span class="fl">优惠卷抵扣:</span>
                    <span class="fr">-{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.couponAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">应付金额:</span>
                    <span class="fr red fwb">{{ getPriceType(detailInfos.priceType).symbol }} {{detailInfos.paymentAmount}} {{ getPriceType(detailInfos.priceType).unit }}</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">支付状态:</span>
                    <span class="fr">{{detailInfos.payStatusDesc}}</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">订单状态:</span>
                    <span class="fr">{{orderStatusTxt(detailInfos)}}</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">创建时间:</span>
                    <span class="fr">{{detailInfos.creationTime}}</span>
                </div>
            </el-card>
            <div class="title">收/寄件人</div>
            <el-card class="box-card" shadow="never">
                <template v-if="!detailInfos.tenantId">
                    <div class="orderinfo">
                        <span class="fl">收件人姓名:</span>
                        <span class="fr">{{detailInfos.addressee && detailInfos.addressee.name}}</span>
                    </div>
                    <div class="orderinfo">
                        <span class="fl">收件人电话:</span>
                        <span class="fr">{{detailInfos.addressee && detailInfos.addressee.tel}}</span>
                    </div>
                    <div class="orderinfo">
                        <span class="fl">收件人地址:</span>
                        <span class="fr">{{detailInfos.addressee && detailInfos.addressee.detailAddress}}</span>
                    </div>
                </template>
                <div class="orderinfo" v-else>
                    <span class="fl">取货方式:</span>
                    <span class="fr">自提</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">寄件人姓名:</span>
                    <span class="fr">{{detailInfos.consignor && detailInfos.consignor.name}}</span>
                </div>
                <div class="orderinfo">
                    <span class="fl">寄件人电话:</span>
                    <span class="fr">{{detailInfos.consignor && detailInfos.consignor.tel}}</span>
                </div>
            </el-card>
            <div class="title">备注说明</div>
            <el-card class="box-card" shadow="never">
                {{detailInfos.remark}}
            </el-card>
            <template v-if="detailInfos.parcelIds && detailInfos.parcelIds.length > 0">
                <div class="title">邮单明细</div>
                <div class="exp_progress">
                    <div v-for="exp in detailInfos.parcelIds" :key="exp" style="margin-top:10px;">
                        <expprogess :expProgressId="exp"></expprogess>
                    </div>
                </div>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDetail = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="修改订单" :visible.sync="isShowDialogInfo"
            width="50%" top="5%" :close-on-click-modal="false"
            custom-class="update_order"
        >
            <el-form ref="updateForm" :model="updateData" label-width="100px" size="mini">
                <template v-if="!updateData.tenantId">
                    <el-form-item label="收件人" class="reclable">
                        <el-button type="warning" @click="choseAddressee()">选择收件人</el-button>
                    </el-form-item>
                    <el-form-item label="姓名" class="readonly">
                        <el-input v-model="updateData.addressee && updateData.addressee.name" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="电话" class="readonly">
                        <el-input v-model="updateData.addressee && updateData.addressee.tel" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号码" class="readonly">
                        <el-input v-model="updateData.addressee && updateData.addressee.idCardNo" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="身份证照片" class="readonly">
                        <span class="idcard">
                            <img :src="updateData.addressee && updateData.addressee.idCardFrontImageUrl"
                                v-if="updateData.addressee && updateData.addressee.idCardFrontImageUrl"
                            />
                        </span>
                        <span class="idcard">
                            <img :src="updateData.addressee && updateData.addressee.idCardBackImageUrl"
                                v-if="updateData.addressee && updateData.addressee.idCardBackImageUrl"
                            />
                        </span>
                    </el-form-item>
                    <el-form-item label="省市区" class="readonly">
                        <el-input v-model="fullAddress" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="详细地址" class="readonly">
                        <el-input v-model="updateData.addressee && updateData.addressee.detail" readonly></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="取货方式" class="reclable" v-else>
                    <el-tag type="danger" plain>自提</el-tag>
                </el-form-item>
                <el-form-item label="寄件人" class="reclable">&nbsp;</el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="updateData.consignor && updateData.consignor.name"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="updateData.consignor && updateData.consignor.tel"></el-input>
                </el-form-item>
                <el-form-item label="订单备注" class="reclable">&nbsp;</el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="updateData.remark" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeOrder()">取 消</el-button>
                <el-button type="primary" @click="saveOrder()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="我的收件人" top="5vh" :visible.sync="receiptorDialogVisible" width="80%"
                   :close-on-click-modal="false" @closed="receiptorDialogVisible=false">
            <cpnpeceiptor :isChoiseReceiptor="receiptorDialogVisible"
                          v-on:choisedReceiptor="choiseReceiptor"></cpnpeceiptor>
        </el-dialog>
    </div>
</template>

<script>
    import areaData from '@/js/area.js'
    import cpnpeceiptor from '@/views/frontend/components/receiptor.vue'
    import expprogess from '@/views/frontend/components/expProgress.vue'
    export default {
        name: 'orders',
        components: {
            cpnpeceiptor, expprogess
        },
        data(){
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                searchDate: null,
                orders:{
                    totalCount:0,
                    items:[]
                },
                detailInfos:{},
                filter:{
                    Status: null,
                    BeginDate:null,
                    EndDate:null,
                    Keywords:null,
                    Page:1,
                    Size:10,
                    priceType: null
                },
                dialogTrace: false,
                dialogDetail: false,
                //修改订单
                isShowDialogInfo: false,
                receiptorDialogVisible: false,
                fullAddress: "",
                updateData: {
                    "tenantId": null,
                    "remark": "",
                    "consignor": {
                        "name": "",
                        "tel": ""
                    },
                    "addressee": {
                        "name": "",
                        "tel": "",
                        "province": "",
                        "city": "",
                        "area": "",
                        "detail": "",
                        "idCardNo": "",
                        "idCardFrontImageUrl": "",
                        "idCardBackImageUrl": ""
                    },
                    "id": ""
                },
                isShowCoupons: false,
                expProgressIds: [],
                myOrderCout: {}
            }
        },
        async mounted(){
            await areaData.getAreasData()
            this.getMyOrderCout()
            this.getOrders();
        },
        methods:{
            changePage(v){
                this.filter.Page=v;
                this.getOrders();
            },
            getMyOrderCout() {
                this.$axios.post(window.consts.apis.queryMyOrderCout).then(r=>{
                    if(r.success){
                        this.myOrderCout = r.result;
                    } else {
                        this.$toast.fail("加载数据失败!")
                    }
                }, error => {
                    this.$toast.fail("加载数据失败!")
                })
            },
            getOrders(){
                this.showPcLoading();
                this.$axios.get(window.consts.apis.getMyOrders,{params:this.filter}).then(r=>{
                    this.hidePcLoading();
                    if(r.success){
                        this.orders = r.result;
                    }else{
                        this.$alert(r.error.message,'');
                    }
                }).catch(e => {
                    this.hidePcLoading();
                    this.$message.error("出错啦，请稍候再试!");
                    return false;
                })
            },
            getOrderDetail(order) {
                this.showPcLoading();
                this.$axios.get(window.consts.apis.orderDetail, {params:{id: order.id}}).then(res => {
                    this.hidePcLoading();
                    if (res.success) {
                        let item = res.result;
                        this.detailInfos = item;
                        this.detailInfos.addressee.detailAddress = areaData.getAreaNames([item.addressee.province, item.addressee.city, item.addressee.area]).join(" ") + " " + item.addressee.detail;
                        let freight = item.freight && item.freight || 0;
                        if (freight > 0) {
                            this.detailInfos.items.push({
                                "commodityId": 0,
                                "commodityName": "快递运费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": freight,
                                "commodityPrice": freight,
                                "quantity": 1
                            });
                        }
                        let takePhotoAmount = item.needTakePhoto && item.takePhotoAmount || 0;
                        if (takePhotoAmount) {
                            this.detailInfos.items.push({
                                "commodityId": 0,
                                "commodityName": "标记拍照服务费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": takePhotoAmount,
                                "commodityPrice": takePhotoAmount,
                                "quantity": 1
                            });
                        }
                        let serviceAmount = item.serviceAmount && item.serviceAmount || 0;
                        if (serviceAmount > 0 && item.payStatus === 2) {
                            this.detailInfos.items.push({
                                "commodityId": 0,
                                "commodityName": "手续费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": serviceAmount,
                                "commodityPrice": serviceAmount,
                                "quantity": 1
                            });
                        }
                        this.dialogDetail = true;
                    }
                }).catch(e => {

                });
            },
            getOrderByStatus(state) {
                this.filter.Page = 1;
                this.filter.Status = state || "";
                this.getOrders();
            },
            updateOrder(order) {
                this.showPcLoading();
                this.$axios.get(window.consts.apis.orderDetail, {params:{id: order.id}}).then(res => {
                    this.hidePcLoading();
                    if (res.success) {
                        let item = res.result;
                        this.updateData.id = item.id;
                        this.updateData.remark = item.remark;
                        this.updateData.consignor = item.consignor;
                        this.updateData.addressee = item.addressee;
                        this.updateData.tenantId = item.tenantId;
                        this.fullAddress = areaData.getAreaNames([item.addressee.province, item.addressee.city, item.addressee.area]).join(" ");
                        this.isShowDialogInfo = true;
                        console.log(this.updateData)
                    }
                }).catch(e => {

                });
            },
            closeOrder() {
                this.isShowDialogInfo = false;
            },
            saveOrder() {
                this.$confirm('确定要修改当前订单吗？', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.showPcLoading();
                    this.$axios.put(window.consts.apis.updateOrder, this.updateData).then(res => {
                        this.hidePcLoading();
                        if (res.success) {
                            this.$message.success({
                                duration: 2000,
                                type: "warning",
                                message: "订单修改成功!",
                                onClose: (rt => {
                                    this.getOrders();
                                    this.closeOrder();
                                })
                            });
                        } else {
                            this.$message.error(res.error.message);
                            return false;
                        }
                    }).catch(e => {
                        this.hidePcLoading();
                        this.$message.error("出错啦，请稍候再试!");
                        return false;
                    });
                }).catch(() => {

                });
            },
            choseAddressee() {
                this.receiptorDialogVisible = true;
            },
            cancelOrder(id) {
                this.$confirm('确定要取消订单吗？', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.showPcLoading();
                    this.$axios.post(window.consts.apis.orderCancel, {id: id}).then(res => {
                        this.hidePcLoading();
                        if (res.success) {
                            let item = res.result;
                            this.$message.success({
                                duration: 2000,
                                type: "warning",
                                message: "订单取消成功!",
                                onClose: (rt => {
                                    this.getOrders();
                                })
                            });
                            this.toClose();
                        } else {
                            this.$message.error(res.error.message);
                            return false;
                        }
                    }).catch(e => {
                        this.hidePcLoading();
                        this.$message.error("出错啦，请稍候再试!");
                        return false;
                    });
                }).catch(() => {

                });
            },
            //选择收件人
            choiseReceiptor (item) {
                this.receiptorDialogVisible = false
                this.updateData.addressee = item.addressee
                this.fullAddress = areaData.getAreaNames([item.addressee.province, item.addressee.city, item.addressee.area]).join(" ");
            },
            search() {
                if (this.searchDate) {
                    this.filter.BeginDate = this.searchDate[0];
                    this.filter.EndDate = `${this.searchDate[1]} 23:59:59`;
                } else {
                    this.filter.BeginDate = this.filter.EndDate = null
                }
                this.getOrders();
            },
            formatPrice(row) {
                return this.getPriceType(this.detailInfos.priceType).symbol + " " + row.commodityPrice + " " + this.getPriceType(this.detailInfos.priceType).unit;
            }
        }
    }
</script>


